import { render, staticRenderFns } from "./google-auth.vue?vue&type=template&id=a1a7f7f0&scoped=true&"
import script from "./google-auth.vue?vue&type=script&lang=js&"
export * from "./google-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a7f7f0",
  null
  
)

export default component.exports